module.exports = __webpack_public_path__ + "static/media/drums.157ab30c.jpg";